import type { FaireProductEntity } from "../../entity_types/product";

export const p_vg7wjrh7pe: FaireProductEntity = {
  token: "p_vg7wjrh7pe",
  type: "product",
  name: "God’s Promise Wooden Rainbow Abacus",
  brandToken: "b_b2bxmek3gf",
  brandName: "Kingdom Come Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/06af22046976e989df8c0650c61f68506662d9cdbbf935ec6e1c5d0a9167be19.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88c0c2181b2b8f837f8c3decc5f4a59ff9c19a98f914c473dbc4406bbeb41d4a.jpeg",
    "https://cdn.faire.com/fastly/576dbb0ec7c3731b38959c57394bf83009783b7a8ed833dcc99a0e3ebee567ce.jpeg",
  ],
  priceDollars: 25.22,
  description:
    "\nIntroducing our beautiful Wooden Rainbow Abacus for babies, a playful and stylish way to introduce your child to the story of Noah's Ark and God's promises. This abacus features four different colored beads, which can be used to teach basic counting skills while also serving as a reminder of the covenant made with Noah.\n\nThe abacus is expertly crafted from high-quality wood and engraved with the text \"God Keeps His Promises,\" providing a tangible and meaningful way to incorporate faith into your child's playtime. The rainbow design is both modern and whimsical, making it a great addition to any nursery decor.\n\nThis Wooden Rainbow Abacus is not just a toy, but a tool for learning and growing in faith.",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:28.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
